import { memo, useMemo, useState } from 'react'
import useGlobalSearchVerticalTabs from 'hooks/GlobalSearch/useGlobalSearchVerticalTabs'

import LayoutContainer from 'components/Common/LayoutContainer'
import GlobalSearchTabsPane from 'components/Search/GlobalSearch/GlobalSearchTabsPane'
import GlobalSearchLoyaltyBurnToggle from 'components/Search/GlobalSearch/GlobalSearchLoyaltyBurnToggle'
import styled from 'styled-components'
import { rem } from 'polished'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const SearchContainer = styled(LayoutContainer)`
  position: relative;
  bottom: ${rem(56)};
  margin-bottom: -${rem(56)};
  padding-bottom: ${rem(20)};
`

interface Props {
  /**
   * Provide your own set of tabs that will appear in the search bar
   */
  tabs?: Map<App.SearchVertical, App.GlobalSearchVerticalTab>
}

function Search(props: Props) {
  const globalTabs = useGlobalSearchVerticalTabs()
  const tabs = props.tabs ?? globalTabs

  const [selectedTab, setSelectedTab] = useState<App.SearchVertical>([...tabs.keys()][0])

  const showPointsToggle = selectedTab === 'hotels' || selectedTab === 'homes-and-villas'

  const bottomSlot = useMemo(() => {
    if (!showPointsToggle) return undefined
    return <GlobalSearchLoyaltyBurnToggle />
  }, [showPointsToggle])

  return (
    <CSSBreakpoint min="desktop">
      <SearchContainer data-testid="search-container">
        <GlobalSearchTabsPane tabs={tabs} selectedTab={selectedTab} onTabSelect={setSelectedTab} bottomSlot={bottomSlot} />
      </SearchContainer>
    </CSSBreakpoint>
  )
}

export default memo(Search)
